import { useTranslation } from "react-i18next";
import styled from "styled-components";
import ExternalLinkIcon from "../img/icons/external-link-icon.svg?react";
import LeaguePassLogo from "../img/league-pass-logo.png";
import PromoItem2x1 from "../img/promo-item2@1x.png";
import PromoItem2x2 from "../img/promo-item2@2x.png";
import PromoItem1x1 from "../img/promo-item@1x.png";
import PromoItem1x2 from "../img/promo-item@2x.png";
import PromoItem3x1 from "../img/promo-item3@1x.png";
import PromoItem3x2 from "../img/promo-item3@2x.png";
import { Main, Wrapper } from "./Layout";
import PostSeasonAlert from "./PostSeasonAlert";

const ContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.space[3]};
  margin-bottom: ${(props) => props.theme.space[3]};
`;

const PromoWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${(props) => props.theme.space[4]};

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

const StyledLeaguePassLogo = styled.div`
  width: 190px;
  height: 52px;
  background-image: url(${LeaguePassLogo});
  background-repeat: no-repeat;
  background-size: contain;
`;

const LogoCopyGap = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.space[4]};

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    gap: ${(props) => props.theme.space[6]};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    gap: ${(props) => props.theme.space[2]};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[5]}) {
    gap: ${(props) => props.theme.space[4]};
  }
`;

const PromoItemCopy = styled.p`
  position: absolute;
  left: ${(props) => props.theme.space[5]};
  bottom: 2px;
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.space[4]};
  max-width: 275px;
  font-size: ${(props) => props.theme.fontSizes[2]};
  color: ${(props) => props.theme.colors.white};

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    bottom: 14px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    bottom: ${(props) => props.theme.space[4]};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    bottom: 0;
    gap: ${(props) => props.theme.space[2]};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[5]}) {
    bottom: ${(props) => props.theme.space[3]};
  }
`;

const PromoLink = styled.a`
  color: ${(props) => props.theme.colors.white};
`;

const PromoItem = styled.img`
  width: 360px;
  height: auto;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    width: 416px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    width: 315px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[5]}) {
    width: 370px;
  }
`;

const CopyPosition = styled.div`
  position: relative;
`;

const StyledExternalLinkIcon = styled(ExternalLinkIcon)`
  margin-left: ${(props) => props.theme.space[3]};
`;

const PostSeason = () => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <Main isWide={true}>
        <ContentWrap>
          <PostSeasonAlert />
          <PromoWrap>
            <CopyPosition>
              <PromoItemCopy>
                {t(
                  "postSeason.promo1.headline",
                  "Read our Season Summary to catch up on all the action.",
                )}

                <PromoLink
                  href="https://www.nba.com/news/nba-fantasy-salary-cap-edition-2025-26-recap-part-1"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t("postSeason.promo1.info", "Read the summary")}
                  <StyledExternalLinkIcon />
                </PromoLink>
              </PromoItemCopy>
              <PromoItem
                srcSet={`${PromoItem1x1}, ${PromoItem1x2} 2x`}
                src={PromoItem1x1}
                alt={t("postSeason.promo1.info", "Read the summary")}
              />
            </CopyPosition>
            <CopyPosition>
              <PromoItemCopy>
                <LogoCopyGap>
                  <StyledLeaguePassLogo />
                  {t(
                    "postSeason.promo2.headline",
                    "Stream the NBA Playoffs with League Pass.",
                  )}
                </LogoCopyGap>
                <PromoLink
                  href="https://www.nba.com/league-pass-purchase"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t("postSeason.promo2.info", "Get League Pass")}
                  <StyledExternalLinkIcon />
                </PromoLink>
              </PromoItemCopy>
              <PromoItem
                srcSet={`${PromoItem2x1}, ${PromoItem2x2} 2x`}
                src={PromoItem2x1}
                alt={t("postSeason.promo2.info", "Get League Pass")}
              />
            </CopyPosition>
            <CopyPosition>
              <PromoItemCopy>
                {t(
                  "postSeason.promo3.headline",
                  "Can you predict the NBA Playoffs? Make your predictions now.",
                )}

                <PromoLink
                  href="https://nba.com/bracket"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t("postSeason.promo3.info", "Play NBA Bracket Challenge")}
                  <StyledExternalLinkIcon />
                </PromoLink>
              </PromoItemCopy>
              <PromoItem
                srcSet={`${PromoItem3x1}, ${PromoItem3x2} 2x`}
                src={PromoItem3x1}
                alt="Read our season summary"
              />
            </CopyPosition>
          </PromoWrap>
        </ContentWrap>
      </Main>
    </Wrapper>
  );
};

export default PostSeason;
